// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-91bc6fc0] .avue-upload__avatar{width:80px;height:80px;line-height:80px}.btnClass[data-v-91bc6fc0]{display:flow-root;height:50px;line-height:50px;padding:0 15px}", ""]);
// Exports
module.exports = exports;
